import { displayMessage } from "../../../../helpers/messages";

const gym_exercise_grid_columns = [
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "order_index",
        headerName: displayMessage("ORDER_INDEX"),
        flex: 0.5,
        minWidth: 80,
    },
    {
        field: "name",
        headerName: displayMessage("EXERCISE_NAME"),
        flex: 2,
        minWidth: 200,
    },
    {
        field: "sets",
        headerName: displayMessage("SETS"),
        flex: 0.5,
        minWidth: 80,
    },
    {
        field: "reps",
        headerName: displayMessage("REPS"),
        flex: 0.8,
        minWidth: 100,
    },
    {
        field: "rest_seconds",
        headerName: displayMessage("REST_SECONDS"),
        flex: 0.8,
        minWidth: 100,
        renderCell: (params) => {
            if (!params.value) return "-";
            return `${params.value}s`;
        },
    },
    {
        field: "video_url",
        headerName: displayMessage("VIDEO_URL"),
        flex: 1.5,
        minWidth: 150,
        renderCell: (params) => {
            if (!params.value) return "-";
            return (
                <a 
                    href={params.value} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-500 underline truncate"
                >
                    Ver vídeo
                </a>
            );
        },
    },
];

export default gym_exercise_grid_columns;


